import ky from "ky";

function redirectToLogin() {
  localStorage.removeItem("loggedInUser");
  window.location.pathname = "/";
}

const PUBLIC_PATH_FRAGMENTS = [
  "users/authenticate",
  "reset-password",
];

function isPublicRequest(request) {
  return PUBLIC_PATH_FRAGMENTS.some((fragment) => request.url.includes(fragment));
}

function checkSessionExpiry() {
  const loggedInUser = localStorage.getItem("loggedInUser");
  if (!loggedInUser) return;

  const userObject = JSON.parse(loggedInUser);
  if (userObject.tokenExpiration) {
    const tokenExp = Date.parse(userObject.tokenExpiration);
    if (Date.now().valueOf() >= tokenExp) {
      redirectToLogin();
    }
  }
}

export const api = ky.extend({
  timeout: 300000,
  prefixUrl: process.env.REACT_APP_BASE_URL,
  credentials: "include",
  hooks: {
    beforeRequest: [
      (request) => {
        if (!isPublicRequest(request)) {
          checkSessionExpiry();
        }
      }
    ],
    afterResponse: [
      (request, options, response) => {
        if (response.status === 401 && !isPublicRequest(request)) {
          console.warn("Unauthorized: Redirecting to login...");
          redirectToLogin();
        }
      }
    ]
  }
});

function getBaseUrl() {
  let baseUrl = "https://rateus.envirolabsinc.com/api/";
  if (process.env.NODE_ENV !== "production") {
    baseUrl = "https://localhost:44349/api/";
  }
  return baseUrl;
}

export async function getBlob(path) {
  const response = await fetch(`${getBaseUrl()}${path}`, {
    method: "GET",
    credentials: "include",
  });

  if (response.ok) {
    return response.blob();
  }

  throw response;
}

export async function getPostBlob(path, json) {
  const headers = new Headers();
  headers.append("Content-Type", "application/json");

  const response = await fetch(`${getBaseUrl()}${path}`, {
    method: "POST",
    headers,
    body: JSON.stringify(json),
    credentials: "include",
  });

  if (!response.ok) {
    throw response;
  }

  return await response.blob();
}
